import { gql } from 'src/generated/gql';

export const GET_PATIENT_PROFILE_PHOTO = gql(`
    query GetPatientProfilePhoto($id: ID!) {
      menuPatient(id: $id) {
        id
        firstName
        lastName
        profilePhoto
        dob
      }
    }
  `);
